// The group roll requests a person holds (issue 1049, DICE-010), beside the log: moved only by what this person
// was sent. Kept out of `dice.ts` so the panels' mocks of the HTTP surface leave it real.
import { reduceAsks, type PlayerAsk, type ProjectedEvent, type RollAsk } from '@dragons-table/vtt-shared';

/** The open group roll requests this person was given (issue 1049): the DM's whole, with who has rolled; a player's own prompts. */
export type Asks = Record<string, RollAsk | PlayerAsk>;

/**
 * The asks moved by one projected event, from what the event carries and nothing else: the DM reduces the event's
 * body with the shared reducer; a player adds the prompt they were sent, drops the one withdrawn, and drops the one
 * their own answer (a roll naming it) settled.
 */
export function foldAsks(asks: Asks, ev: ProjectedEvent, meId: string): Asks {
  if (ev.kind === 'dm.event') {
    const b = ev.body;
    if (b.kind !== 'roll.ask' && b.kind !== 'roll.ask.close' && b.kind !== 'roll') return asks;
    return reduceAsks(asks as Record<string, RollAsk>, b);
  }
  if (ev.kind === 'ask.set') return { ...asks, [ev.ask.id]: ev.ask };
  const gone = ev.kind === 'ask.clear' ? ev.id : ev.kind === 'roll' && ev.roll.ask && ev.roll.actor.id === meId && !ev.roll.by ? ev.roll.ask : null;
  if (!gone || !asks[gone]) return asks;
  const { [gone]: _gone, ...rest } = asks;
  return rest;
}
